import { render, staticRenderFns } from "./academicPaper.vue?vue&type=template&id=6ed75995&scoped=true&"
import script from "./academicPaper.vue?vue&type=script&lang=js&"
export * from "./academicPaper.vue?vue&type=script&lang=js&"
import style0 from "./academicPaper.vue?vue&type=style&index=0&id=6ed75995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed75995",
  null
  
)

export default component.exports